import api from "./api";

export const ContractsAPI = {
  list: () => api("/contracts"),
  get: (id) => api(`/contracts/${id}`),
  create: (data) =>
    api("/contracts", { method: "POST", body: JSON.stringify(data) }),
  update: (id, data) =>
    api(`/contracts/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  delete: (id) => api(`/contracts/${id}`, { method: "DELETE" }),
};